// Archivo centralizado de entornos

export type Environment = 'dev' | 'pre' | 'prod';

let ENVIRONMENT: Environment = 'dev'; // Valor por defecto, se sobrescribe en runtime

export const setEnvironment = (env: Environment) => {
  ENVIRONMENT = env;
};

// URLs por entorno
const environments = {
  dev: {
    API_URL: 'https://localhost:56544/api'
  },
  pre: {
    API_URL: 'https://dinasa.wskserver.com:56544/api'
  },
  prod: {
    API_URL: 'https://erp.wskserver.com:56544/api'
  }
};

// Constantes globales (iguales para todos los entornos)
export const DEFAULT_COMPANY = '1';
export const API_ENDPOINTS = {
  LOGIN: '/login/authenticate',
  CONSULT_CONTRACT: '/ContratoCertificacion/consultcontract',
  GET_MILESTONES: '/ContratoCertificacion/getagreementmilestones',
  UPDATE_CONTRACT: '/ContratoCertificacion/updatecontract',
  LOGINUSER: '/User/getbycodv2',
  GET_CONTRACTS_LIST: '/ContratoCertificacion/getcontratcts'
};

// Exportar la URL del API según el entorno actual
export const getApiUrl = () => environments[ENVIRONMENT].API_URL;
export { ENVIRONMENT }; 